// extracted by mini-css-extract-plugin
export default {"card":"card--bZcSHF5T","ui-red-weak":"ui-red-weak--H0KqkeKY","uiRedWeak":"ui-red-weak--H0KqkeKY","ui-green":"ui-green--GdPq0Un3","uiGreen":"ui-green--GdPq0Un3"};